import actions from './constants';

const showAnnouncements = (category, results) => ({
  type: actions.SHOW_ANNOUNCEMENTS,
  category,
  results,
});

export default showAnnouncements;
